import React from 'react'

import AutoCompleteAddressInput from './AutoCompleteAddressInput';
import AutoCompleteAddressResults from './AutoCompleteAddressResults';
import ConfirmAddressButton from './ConfirmAddressButton';
import MapViewer from './MapViewer';
import MapMarker from './MapMarker';
import LocalizeButton from './LocalizeButton';
import SearchAddressService from '../services/SearchAddressService';
import Geolocalizer from '../services/Geolocalizer';
import Geocoder from '../services/Geocoder';
import {getAddressComponent} from "../services/PlaceService";

const DEFAULT_LAT = 45.663825;
const DEFAULT_LNG = 12.250616;

function getFullAddress(address_components) {
    const street_name   = getAddressComponent(["route"], address_components);
    const street_number = getAddressComponent(["street_number"], address_components);
    const city = getAddressComponent(["locality","administrative_area_level_3"], address_components);

    return `${street_name} ${street_number || ''}, ${city}`;
}

function getErrorMessage(error) {
    let message;

    switch (error.code) {
        case error.PERMISSION_DENIED:
            message = I18n.t("mobileapp.pages.locations.search.localization.not_enabled");
            break;
        case error.POSITION_UNAVAILABLE:
            message = I18n.t("mobileapp.pages.locations.search.localization.cannot_retrieve"); //"Location information is unavailable.";
            break;
        case error.TIMEOUT:
            message = I18n.t("mobileapp.pages.locations.search.localization.timeout");  //"The request to get user location timed out.";
            break;
        default:
            message = I18n.t("mobileapp.pages.locations.search.localization.cannot_retrieve");
            break;
    }

    return message;
}

export default class MapAddressPickerContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            addresses: [],
            value: props.initialFullAddress || '',
            operationInProgress: false,
            showMap: true,
            mapZoom: 17,
            chosenAddress: {
                description: props.initialFullAddress,
                lat: parseFloat(props.initialLat) || DEFAULT_LAT,
                lng: parseFloat(props.initialLng) || DEFAULT_LNG,
                components: []
            },
            localization: {
                enabled: false,
                accuracy: null,
                lat: null,
                lng: null
            }
        };


        this.searchAddressService = new SearchAddressService();
        this.geolocalizer = new Geolocalizer();
        this.geolocalizeUserTimeout = null;
    }

    componentWillUnmount() {
        this.clearGeolocalizerUserTimeout();
    }

    componentDidMount() {
        if (this.props.autoGeolocalizeUser) {
            this.geolocalizeUser(true);
        }
    }

    geolocalizeUser = (autoCenterMap = false) => {
        this.geolocalizer.localize(
            (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                const gpsAccuracy = position.coords.accuracy;

                let newState = {
                    localization: {
                        enabled: true,
                        accuracy: gpsAccuracy,
                        lat: lat,
                        lng: lng
                    }
                };

                if (autoCenterMap === true) {
                    newState.mapZoom = 18;

                    this.setState(newState);
                    this.handleOnMapCenterChange(lat, lng);
                } else {
                    this.setState(newState);
                }

                this.geolocalizeUserTimeout = setTimeout(this.geolocalizeUser, 3000); // refresh for better position

                //localizationStatusLabel.setText(I18n.t("mobileapp.pages.locations.search.localization.accuracy_label", {meters: parseInt(gpsAccuracy) }));
            }, (error) => {

                this.clearGeolocalizerUserTimeout();
                alert(getErrorMessage(error));
            });
    };

    handleOnMapZoomChange = (zoom) => {
        this.setState({
            mapZoom: zoom
        });
    };

    handleOnLocalizeClick = () => {
        this.clearGeolocalizerUserTimeout();
        this.geolocalizeUser(true);
    };

    handleOnInputChange = (term) => {
        if (term.length === 0) {
            this.setState({
                addresses: [],
                showMap: true,
                value: '',
            });
        } else {
            let token = this.state.token;

            if (!token) {
                token = new google.maps.places.AutocompleteSessionToken();
                this.setState({token: token})
            }

            this.setState({
                value: term,
            });

            this.searchAddressService.search(token, term, (results) => {
                this.setState({
                    addresses: results,
                    showMap: false
                })
            });
        }
    };

    // @placeResult of type: google.maps.places.PlaceResult
    handleAddressClicked = (placeResult) => {
        const location = placeResult.geometry.location;
        const address_components = placeResult.address_components;
        const description = getFullAddress(address_components);

        this.setState({
            value: description,
            showMap: true,
            token: null,
            chosenAddress: {
                lat: location.lat(),
                lng: location.lng(),
                description: description,
                components: address_components
            }
        });
    };

    handleOnMapCenterChange = (lat, lng) => {
        this.setState({
            operationInProgress: true
        });

        Geocoder.geocodePoint(lat, lng, (result) => {
            const address_components = result.address_components;

            if ((typeof this.props.onConfirm === 'function') && address_components) {

                const description = getFullAddress(address_components);

                this.setState({
                    operationInProgress: false,
                    value: description,
                    chosenAddress: {
                        lat: lat,
                        lng: lng,
                        description: description,
                        components: result.address_components
                    }
                });
            }
        });
    };

    handleConfirmButtonClicked = () => {
        this.props.onConfirm(this.state.chosenAddress.lat, this.state.chosenAddress.lng, this.state.chosenAddress.components);
    };

    clearGeolocalizerUserTimeout = () => {
        if (this.geolocalizeUserTimeout) {
            clearTimeout(this.geolocalizeUserTimeout);
        }
    };

    isAddressFilled() {
        const { lat, lng, description } = this.state.chosenAddress;

        return lat && lng && description;
    }

    renderMap() {
        return (
            <MapViewer ref="mapViewer"
                       initialCenterLat={this.state.chosenAddress.lat}
                       initialCenterLng={this.state.chosenAddress.lng}
                       zoom={this.state.mapZoom}
                       onCenterChange={this.handleOnMapCenterChange}
                       onZoomChange={this.handleOnMapZoomChange}
                       localization={this.state.localization}>
                <MapMarker/>
                <LocalizeButton onClick={ this.handleOnLocalizeClick }/>
            </MapViewer>
        );
    }

    renderAutoCompleteResults() {
        return <AutoCompleteAddressResults token={this.state.token}
                                           addresses={this.state.addresses}
                                           onAddressClicked={this.handleAddressClicked}/>;
    }

    render() {
        const { operationInProgress, value, showMap } = this.state;
        const buttonText =  operationInProgress ? 'Attendi...' : ' Conferma indirizzo';
        const confirmButtonDisabled = !this.isAddressFilled();

        return (
            <div className="address-picker-modal-body">
                <div className="address-picker-modal-body__input">
                    <AutoCompleteAddressInput
                        disabled={operationInProgress}
                        value={value}
                        onChange={this.handleOnInputChange}/>
                </div>

                <div className="address-picker-modal-body__middle">
                    { showMap ? this.renderMap() : this.renderAutoCompleteResults() }
                </div>

                <div className="address-picker-modal-body__footer">
                    <ConfirmAddressButton
                        disabled={confirmButtonDisabled || operationInProgress}
                        onClick={this.handleConfirmButtonClicked}
                        text={buttonText}/>
                </div>
            </div>
        )
    }
}
